import { IconClock } from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';
import { Text } from '@chakra-ui/react/text';

import { formatDuration } from '@/utils/commonFormats';

const Duration = ({ durationInMs }: { durationInMs: number }) => {
  return (
    <Box display="flex" alignItems="center" gap="4">
      <IconClock size="16" color="icon/tertiary" />
      <Text textStyle="body/md/regular" color="text/secondary">
        {formatDuration(durationInMs / 1000)}
      </Text>
    </Box>
  );
};

export default Duration;
